import React from 'react'
// import { Link, useNavigate } from 'react-router-dom';
import { motion } from 'framer-motion';
import { Link } from 'react-router-dom';
import { Helmet } from 'react-helmet-async';
function Solar() {
    const clients = [
        {
            img: "/assets/services/roof-top-ac-dc-box.svg",
            title: "Solar Cables &amp; Connectors",
            text: "These are installed between solar PV modules and the DC side of the inverter and houses protection devices such as isolators, MCB’s, SPD’s etc.",
            link: "/services/roof-top-ac-dc-distribution-box"
        },
        {
            img: "/assets/services/pa12-solar-cable-ties.svg",
            title: "Roof Top AC and DC Distribution Box Solutions",
            text: "Comprehensive range of cable securing solutions including cable ties, cable tie mounts, cable clips and stainless-steel strapping & buckle are available.",
            link: "/services/pa12-solar-photovoltaic-cable-ties"
        },
        {
            img: "/assets/services/identification-labelling-systems.svg",
            title: "PA12 Solar/Photovoltaic Cable Ties &amp; Edge Clips",
            text: "Reliable solar farm identification label materials using IEC 61730-2: 2023 are available to withstand UV resistance, humidity, chemical, temperature cycling & abrasion.",
            link: "/services/identification-labelling-systems"
        },
        {
            img: "/assets/services/conduits-cable-glands-accessories.svg",
            title: "Identification and Labelling Systems",
            text: "A range of polymer cable glands and conduits to suit UV with vibration and strain relief.",
            link: "/services/conduits-cable-glands-accessories"
        },
          {
            img: "/assets/services/identification-labelling-systems.svg",
            title: "Flexible Conduit &amp; Cable Tray",
            text: "Reliable solar farm identification label materials using IEC 61730-2: 2023 are available to withstand UV resistance, humidity, chemical, temperature cycling & abrasion.",
            link: "/services/identification-labelling-systems"
        },
          {
            img: "/assets/services/identification-labelling-systems.svg",
            title: "Cable Glands, Lugs &amp; Accessories",
            text: "Reliable solar farm identification label materials using IEC 61730-2: 2023 are available to withstand UV resistance, humidity, chemical, temperature cycling & abrasion.",
            link: "/services/identification-labelling-systems"
        },
    ];

    return (
        <>
        <Helmet>
    <title>
        Solar Cable Management & Electrical Solutions UAE | Al Ibtekar
    </title>

    <meta
        name="description"
        content="Al Ibtekar provides solar cable management and electrical solutions in the UAE, including solar cables, connectors, AC and DC distribution boxes, PV cable ties, labelling systems, flexible conduits, cable trays, glands, lugs and accessories."
    />

    <meta
        name="keywords"
        content="solar cable management UAE, solar cables UAE, solar connectors UAE, solar cable ties UAE, photovoltaic cable ties UAE, solar distribution box UAE, solar cable glands UAE, solar cable accessories UAE, solar electrical solutions UAE, solar farm cable management UAE"
    />

    <link
        rel="canonical"
        href="https://saig.me/solar"
    />

    <meta
        property="og:title"
        content="Solar Cable Management & Electrical Solutions UAE | Al Ibtekar"
    />

    <meta
        property="og:description"
        content="Solar cable management and electrical solutions for solar farms and photovoltaic applications across the UAE."
    />

    <meta
        property="og:url"
        content="https://saig.me/solar"
    />

    <meta
        property="og:type"
        content="website"
    />
</Helmet>
            <div className='newbanner-about newbanner-about3'>
                <div className="max-w-[1440px] w-full mx-auto lg:px-[50px] px-[20px]">
                    <h6 className="font-[500] font-kanit lg:text-[60px] text-[30px] lg:leading-[90px] leading-[40px] text-[#FFFFFF] lg:pb-[14px] pb-[4px]">Solar</h6>
                    <p className="lg:max-w-[582px] max-w-[250px] w-full font-[300] font-inter lg:text-[20px] text-[12px] lg:leading-[30px] leading-[16px] text-[#FFFFFF]">Empowering the future with clean and renewable solar energy.
                    </p>
                </div>
            </div>

              <div className='newbg'>

               <div className='max-w-[1440px] w-full mx-auto lg:px-[50px] px-[20px] overflow-hidden allheader mb-[20px]'>
  <h2>Solar</h2>
  <div className='line'></div>
                         <h3 className='text-justify'>Renewables are the next generation of cleaner energy, that the world is looking at to reduce carbon footprint and global warming. Solar energy involves the use of solar panels stretching acres of lands to capture the solar energy that reaches the earth. Due to the vastness of the solar field cable management is an important element of the project.
<br/><br/>
<span style={{fontWeight:'600'}}>With our desert climatic experience and harsh weather conditions we provide time-tested cost- effective solutions viz.</span>
</h3>

               </div>
               </div>

            <section className='lg:pt-[10px] pt-[10px] lg:pb-[20px] pb-[20px]'>

          <div className="grid lg:grid-cols-2 grid-cols-1 items-center pb-[36px] lg:gap-[90px] gap-[30px] max-w-[1440px] w-full mx-auto lg:px-[50px] px-[20px]">

  <div>
    <div className=' mb-[15px] w-full flex justify-center items-center rounded-[12px] p-[22px]'>
      <img 
        src="/assets/solarinner.png" 
        className='rounded-[12px]' 
        alt="Trusted cable management and termination solutions provider in the UAE" 
      />
    </div>
  </div>

  <div className='pt-[11px]'>
    <ul className="mt-4 grid grid-cols-1">
      {[
        "Solar Cables & Connectors",
        "Roof Top AC and DC Distribution Box Solutions",
        "PA12 Solar/Photovoltaic Cable Ties & Edge Clips",
        "Identification and Labelling Systems",
        "Flexible Conduit & Cable Tray",
        "Cable Glands, Lugs & Accessories",
      ].map((item, i) => (
        <li
          key={i}
          className="flex items-start gap-3 rounded-lg bg-white px-4 py-1 transition"
        >
          <span className="mt-1 text-[#e09e0f] text-sm font-semibold">●</span>
          <span className="text-gray-700 text-[18px] leading-relaxed aplus">
            {item}
          </span>
        </li>
      ))}
    </ul>

   <Link to="/industries">
                          <button className="backbtn">Back To Industries</button>
                        </Link>
  </div>

</div>

             




            </section>


        </>
    )
}

export default Solar